module.exports = __webpack_public_path__ + "static/desktopHero-fedd26a73c1b0a7833eecf776c583143.png";